import useSWR from "swr";
import { type User } from "../types";
import { type UserStatus, type PlatformRole } from "~/config/types";
import { simpleFetcher } from "../fetcher";
import { useUserContext } from "~/hooks/useUserContext";
import { currentUserAtTopCompareFn } from "~/helpers/user";

interface Props {
  status?: UserStatus[];
  roles?: PlatformRole[];
  putCurrentUserAtTop?: boolean;
}

function useUsers({ status, roles, putCurrentUserAtTop }: Props) {
  const { user } = useUserContext();

  let url = "/api/v2/users";

  const params = new URLSearchParams();
  if (status?.length) params.set("status", status.join(","));
  if (roles?.length) params.set("roles", roles.join(","));
  const query = params.toString();
  if (query) url += `?${query}`;

  const swr = useSWR<User[], Error>(url, simpleFetcher, {
    revalidateOnFocus: false,
  });

  return {
    ...swr,
    data: putCurrentUserAtTop
      ? swr.data?.toSorted((a, b) =>
          currentUserAtTopCompareFn(a.id, b.id, user.id),
        )
      : swr.data,
  };
}

export default useUsers;
